<template>
  <div class="navbar-wrapper">
    <nav class="navbar">
      <div class="logo">
        <router-link to="/"
          ><img src="@/assets/RHDesign.webp" alt="RHDesign logo" />
        </router-link>
      </div>
      <ul class="nav-items">
        <li>
          <router-link to="/quote" active-class="active">Quote</router-link>
        </li>

        <li>
          <router-link to="/gallery" active-class="active">Gallery</router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-wrapper {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background-color: #000;
  width: 100%;
  min-width: 300px;
  box-shadow: rgba(0, 0, 0, 0.59) 0px 5px 10px, rgba(0, 0, 0, 0.3) 0px 6px 6px;
}

.navbar {
  max-width: 1300px;

  margin: auto;
  display: grid;
  grid-template-columns: 1fr;
  padding-top: 1rem;
  height: 110px;
}

.logo img {
  width: 50%;
}
.nav-items {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-items li:hover {
  transition: all 0.2s ease-in-out;
  transform: scale(1.05);
}

.nav-items li a {
  text-transform: uppercase;
  color: #ffffff;
  margin: 0 0.75rem;
  line-height: 2.5;
}

.nav-items a.active {
  color: #00ddb8;
}

/* *********************************************** Media queries ********************************** */
@media screen and (min-width: 500px) {
}
@media screen and (min-width: 768px) {
  .navbar {
    padding: 0 2rem;
    align-content: center;
    grid-template-columns: repeat(2, 1fr);
  }
  .nav-items {
    justify-content: flex-end;
  }
  .nav-items li a {
    font-size: 1.2rem;
  }
  .logo {
    text-align: left;
  }
}
</style>
